module.exports = "/images/vendor/vue-paycard/src/18.jpg?53e788093fe0187b98da335af5c9f10d";